module.exports = __webpack_public_path__ + "img/0-09.efbf8a21.jpg";